(() => {
  if (window.dcMotionLoaded) return;
  window.dcMotionLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const play = (element, delay = 0) => {
    if (reduced.matches || !element.animate || !element.getClientRects().length) return;
    const animation = element.animate([
      { opacity: 0.35, transform: 'translateY(16px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 460, delay, easing: 'cubic-bezier(.2,.7,.2,1)' });
    animations.add(animation);
    animation.finished.catch(() => {}).finally(() => animations.delete(animation));
  };
  // Content stays visible without JavaScript and never waits for an observer.
  const seen = new WeakSet();
  const selector = '.dc .section-head, .dc .collection-card, .dc .dc-product, .dc .editorial-copy, .dc .standards-grid article, .lf-ct-head, .lf-ct-channel';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let index = 0;
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      play(entry.target, Math.min(index++ * 65, 195));
    });
  }, { threshold: 0.12 }) : null;
  const scan = root => {
    root.querySelectorAll(selector).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top >= innerHeight && !reduced.matches) observer?.observe(element);
    });
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.lf-ct-faq-item[open]')) {
      const answer = event.target.querySelector('.lf-ct-faq-a');
      if (answer) play(answer);
    }
  }, true);
  const main = document.getElementById('main');
  if (main) new MutationObserver(records => {
    records.forEach(({target}) => {
      if (!target.hidden && target.matches('.dc-details-panel, .dc .dc-product')) play(target);
    });
  }).observe(main, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      animations.forEach(animation => animation.cancel());
    }
  });
})();
